import PropTypes from 'prop-types'
import React from 'react'
import Tray from 'mobile/components/trays/tray'
import Login from 'mobile/containers/auth/login'
import SiteLocation from 'base/constants/site_location'

function ReferralModal({ onRequestClose, onLoginSuccess }) {
  return (
    <Tray title="Join Everlane" onRequestClose={onRequestClose}>
      <div className="referral-modal">
        <div className="referral-modal__header">
          <h1 className="referral-modal__header-tagline">
            You’ve been invited
            <br />
            to get a sneak peek!
          </h1>
          <p className="referral-modal__header-subtext">
            Enter your email below and get early access to upcoming product launches.
            <br />
            Stay in the know, on the go.
          </p>
        </div>
        <div className="referral-modal__login-container">
          <Login
            onSignInSuccess={onLoginSuccess}
            onSignUpSuccess={onLoginSuccess}
            siteLocation={SiteLocation.REFERRAL_BANNER}
          />
        </div>
      </div>
    </Tray>
  )
}

ReferralModal.propTypes = {
  onRequestClose: PropTypes.func,
  onLoginSuccess: PropTypes.func,
}

export default ReferralModal
